import React, { useEffect, useState } from "react";


import {
    isCreditCard, isIBAN
} from "validator";


import {
    Row, Col
} from "react-bootstrap";


import {
    SvgIconComponent
} from "@Components/Elements";

import {
    ButtonComponent
} from "@Components/Forms";


import {
    DefaultPopupComponent,
    DropdownFieldComponent, DropdownFieldOptionInterface,
    InputFieldComponent,
    FormFieldStatusInterface,
} from "@Elements";


import IconBankAccountSmGrey from "@Pages/@@UserPages/@@Dashboard/@Wallet/@Icons/icon-bank-sm-grey.svg";
import IconCreditCardSmGrey from "@Pages/@@UserPages/@@Dashboard/@Wallet/@Icons/icon-credit_card-sm-grey.svg";
import IconLockXsGrey from "@Pages/@@UserPages/@@Dashboard/@Wallet/@Icons/icon-lock-xs-grey.svg";


import "./index.scss";


const AddNewAccountDropdownOptions:DropdownFieldOptionInterface[] = [
    {
        optionId: 0,
        optionText: "- Choose -",
    },
    {
        optionId: 1,
        optionText: "Credit Card",
        optionIconLeft: IconCreditCardSmGrey
    },
    {
        optionId: 2,
        optionText: "Bank Account",
        optionIconLeft: IconBankAccountSmGrey
    },
];


interface UserDashboardWalletAddNewAccountComponentProps {
    popupCloseCallback: () => void;
    addPaymentMethodType: "ACCOUNT" | "CARD";
}


export const UserDashboardWalletAddNewAccountComponent:React.FC<UserDashboardWalletAddNewAccountComponentProps> = ({
    popupCloseCallback,
    addPaymentMethodType
}) => {


    const [addNewWithdrawAccountAccountNumber, setAddNewWithdrawAccountAccountNumber] = useState('');

    const [addNewWithdrawAccountHolderFirstName, setAddNewWithdrawAccountHolderFirstName] = useState('');
    const [addNewWithdrawAccountHolderLastName, setAddNewWithdrawAccountHolderLastName] = useState('');

    const [addNewWithdrawCardExpirationDate, setAddNewWithdrawCardExpirationDate] = useState('');
    const [addNewWithdrawAccountCardCvcNumber, setAddNewWithdrawAccountCardCvcNumber] = useState('');


    const [addNewWithdrawAccountAccountNumberStatus, setAddNewWithdrawAccountAccountNumberStatus] = useState<FormFieldStatusInterface | null>(null);

    const [addNewWithdrawAccountHolderFirstNameStatus, setAddNewWithdrawAccountHolderFirstNameStatus] = useState<FormFieldStatusInterface | null>(null);
    const [addNewWithdrawAccountHolderLastNameStatus, setAddNewWithdrawAccountHolderLastNameStatus] = useState<FormFieldStatusInterface | null>(null);

    const [addNewWithdrawCardExpirationDateStatus, setAddNewWithdrawCardExpirationDateStatus] = useState<FormFieldStatusInterface | null>(null);
    const [addNewWithdrawAccountCardCvcNumberStatus, setAddNewWithdrawAccountCardCvcNumberStatus] = useState<FormFieldStatusInterface | null>(null);

    useEffect(() => {
        return () => {
            setAddNewWithdrawAccountAccountNumber('');
            setAddNewWithdrawAccountHolderFirstName('');
            setAddNewWithdrawAccountHolderLastName('');
            setAddNewWithdrawCardExpirationDate('');
            setAddNewWithdrawAccountCardCvcNumber('');
            setAddNewWithdrawAccountAccountNumberStatus(null);
            setAddNewWithdrawAccountHolderFirstNameStatus(null);
            setAddNewWithdrawAccountHolderLastNameStatus(null);
            setAddNewWithdrawCardExpirationDateStatus(null);
            setAddNewWithdrawAccountCardCvcNumberStatus(null);
        };
    }, []);

    const changeAddNewWithdrawAccountAccountNumber = (e:React.ChangeEvent<HTMLInputElement>) => {
        const fieldValue = e.target.value;
        if (addPaymentMethodType === 'CARD') {
            if (isCreditCard(fieldValue) && addNewWithdrawAccountAccountNumberStatus?.statusType === 'error') {
                setAddNewWithdrawAccountAccountNumberStatus(null);
            }
        } else if (addPaymentMethodType === 'ACCOUNT') {
            if (isIBAN(fieldValue) && addNewWithdrawAccountAccountNumberStatus?.statusType === 'error') {
                setAddNewWithdrawAccountAccountNumberStatus(null);
            }
        }
        setAddNewWithdrawAccountAccountNumber(fieldValue);
    };

    const changeAddNewWithdrawAccountHolderFirstName = (e:React.ChangeEvent<HTMLInputElement>) => {
        const fieldValue = e.target.value;
        if (fieldValue.length > 1 && addNewWithdrawAccountHolderFirstNameStatus?.statusType === 'error') {
            setAddNewWithdrawAccountHolderFirstNameStatus(null);
        }
        setAddNewWithdrawAccountHolderFirstName(fieldValue);
    };

    const changeAddNewWithdrawAccountHolderLastName = (e:React.ChangeEvent<HTMLInputElement>) => {
        const fieldValue = e.target.value;
        if (fieldValue.length > 1 && addNewWithdrawAccountHolderLastNameStatus?.statusType === 'error') {
            setAddNewWithdrawAccountHolderLastNameStatus(null);
        }
        setAddNewWithdrawAccountHolderLastName(fieldValue);
    };

    const changeAddNewWithdrawCardExpirationDate = (e:React.ChangeEvent<HTMLInputElement>) => {
        const fieldValue = e.target.value;
        setAddNewWithdrawCardExpirationDate(fieldValue);
    };

    const changeAddNewWithdrawAccountCardCvcNumber = (e:React.ChangeEvent<HTMLInputElement>) => {
        const fieldValue = e.target.value;
        if (fieldValue.length > 3) {
            return;
        }
        setAddNewWithdrawAccountCardCvcNumber(fieldValue);
    }


    const addNewAccountSubmitHandler = () => {

        let error = false;

        // if (addNewWithdrawAccountType === 0) {
        //     error = true;
        //     setAddNewWithdrawAccountTypeStatus({ statusType: 'error', statusMessage: 'You need to choose account type' });
        // }

        if (addPaymentMethodType === 'CARD') {
            if (!isCreditCard(addNewWithdrawAccountAccountNumber)) {
                error = true;
                setAddNewWithdrawAccountAccountNumberStatus({ statusType: 'error', statusMessage: 'Wrong card number' })
            }
        } else if (addPaymentMethodType === 'ACCOUNT') {
            if (!isIBAN(addNewWithdrawAccountAccountNumber)) {
                error = true;
                setAddNewWithdrawAccountAccountNumberStatus({ statusType: 'error', statusMessage: 'Wrong IBAN number' })
            }
        }

        if (addPaymentMethodType === 'CARD') {

            if (!addNewWithdrawCardExpirationDate) {
                error = true;
                setAddNewWithdrawCardExpirationDateStatus({ statusType: 'error', statusMessage: 'Wrong Date Format' });
            }

            if (addNewWithdrawAccountCardCvcNumber.length < 3) {
                error = true;
                setAddNewWithdrawAccountCardCvcNumberStatus({ statusType: 'error', statusMessage: 'Wrong CVC Number' });
            }

        }

        if (addPaymentMethodType === 'ACCOUNT') {

            if (addNewWithdrawAccountHolderFirstName.length < 2) {
                error = true;
                setAddNewWithdrawAccountHolderFirstNameStatus({ statusType: 'error', statusMessage: 'First Name is required.' });
            }

            if (addNewWithdrawAccountHolderLastName.length < 2) {
                error = true;
                setAddNewWithdrawAccountHolderLastNameStatus({ statusType: 'error', statusMessage: 'Last Name is required.' });
            }

        }

        if (error) {
            return;
        }

        addNewAccountRequestHandler();

    };


    const addNewAccountRequestHandler = () => {

        let addNewAccountStoredData: any = localStorage.getItem('USER_PAYMENT_METHODS');

        if (addNewAccountStoredData) {
            addNewAccountStoredData = JSON.parse(addNewAccountStoredData);
        } else {
            addNewAccountStoredData = {
                'CARD': null,
                'ACCOUNT': null,
            };
        }

        if (addPaymentMethodType === 'CARD') {
            addNewAccountStoredData.CARD = {
                'payment_method_card_number': addNewWithdrawAccountAccountNumber,
                'payment_method_card_expiration_date': addNewWithdrawCardExpirationDate,
                'payment_method_card_cvc_number': addNewWithdrawAccountCardCvcNumber,
            };
        } else if (addPaymentMethodType === 'ACCOUNT') {
            addNewAccountStoredData.ACCOUNT = {
                'payment_method_account_number': addNewWithdrawAccountAccountNumber,
                'payment_method_account_first_name': addNewWithdrawAccountHolderFirstName,
                'payment_method_account_last_name': addNewWithdrawAccountHolderLastName,
            };
        }

        localStorage.setItem(
            'USER_PAYMENT_METHODS',
            JSON.stringify(addNewAccountStoredData),
        );

        popupCloseCallback();

    };


    let addPaymentMethodPopupHeader = '';

    switch (addPaymentMethodType) {
        case "ACCOUNT":
            addPaymentMethodPopupHeader = 'Add a payment account';
            break;
        case "CARD":
            addPaymentMethodPopupHeader = 'Add a payment card';
            break;
    }


    return (
        <DefaultPopupComponent
            popupHeaderText={addPaymentMethodPopupHeader}
            popupCloseButtonCallback={popupCloseCallback}
        >

            <Col xs={12} className={'user-wallet-add-card-popup-content'}>
                <Row className={'user-wallet-add-card-popup-content__popup-content'}>

                    {/*<DropdownFieldComponent*/}
                    {/*    dropdownFieldOptions={AddNewAccountDropdownOptions} dropdownFieldOptionSelected={addNewWithdrawAccountType}*/}
                    {/*    dropdownFieldLabel={'Account Type'} dropdownFieldRequiredStatus={true}*/}
                    {/*    dropdownFieldOnChangeCallback={changeNewWithdrawAccountType}*/}
                    {/*    dropdownFieldStatus={addNewWithdrawAccountTypeStatus}*/}
                    {/*/>*/}

                    <Col xs={12} className={'user-wallet-add-card-popup-content__popup-legend'}>
                        <span className={'user-wallet-add-card-popup-content__popup-legend__legend-content'}>
                            <span className={'user-wallet-add-card-popup-content__popup-legend__legend-content__legend-req-status'}>*</span>
                            <span className={'user-wallet-add-card-popup-content__popup-legend__legend-content__legend-text'}>Required fields</span>
                        </span>
                    </Col>

                    {addPaymentMethodType === 'CARD' && (
                    <>
                     <InputFieldComponent
                         inputFieldType={'number'} min={1}
                         inputFieldLabel={'Card number'} inputFieldRequiredStatus={true}
                         inputFieldValue={addNewWithdrawAccountAccountNumber} inputFieldValueHandler={changeAddNewWithdrawAccountAccountNumber}
                         inputFieldStatus={addNewWithdrawAccountAccountNumberStatus}
                     />
                     <InputFieldComponent xs={6}
                         inputFieldType={'text'}
                         inputFieldLabel={'Card expiration date'} inputFieldRequiredStatus={true}
                         inputFieldValue={addNewWithdrawCardExpirationDate} inputFieldValueHandler={changeAddNewWithdrawCardExpirationDate}
                        inputFieldStatus={addNewWithdrawCardExpirationDateStatus}
                     />
                     <InputFieldComponent xs={6}
                         inputFieldType={'number'} min={1}
                         inputFieldLabel={'CVC'} inputFieldRequiredStatus={true}
                         inputFieldValue={addNewWithdrawAccountCardCvcNumber} inputFieldValueHandler={changeAddNewWithdrawAccountCardCvcNumber}
                        inputFieldStatus={addNewWithdrawAccountCardCvcNumberStatus}
                     />
                    </>
                    )}

                    {addPaymentMethodType === 'ACCOUNT' && (
                    <>
                    <InputFieldComponent
                        inputFieldLabel={'Account Number'} inputFieldRequiredStatus={true}
                        inputFieldValue={addNewWithdrawAccountAccountNumber} inputFieldValueHandler={changeAddNewWithdrawAccountAccountNumber}
                        inputFieldStatus={addNewWithdrawAccountAccountNumberStatus}
                    />
                    <InputFieldComponent xs={6}
                        inputFieldLabel={'First Name'} inputFieldRequiredStatus={true}
                        inputFieldValue={addNewWithdrawAccountHolderFirstName} inputFieldValueHandler={changeAddNewWithdrawAccountHolderFirstName}
                        inputFieldStatus={addNewWithdrawAccountHolderFirstNameStatus}
                    />
                    <InputFieldComponent xs={6}
                        inputFieldLabel={'Last Name'} inputFieldRequiredStatus={true}
                        inputFieldValue={addNewWithdrawAccountHolderLastName} inputFieldValueHandler={changeAddNewWithdrawAccountHolderLastName}
                        inputFieldStatus={addNewWithdrawAccountHolderLastNameStatus}
                    />
                    </>
                    )}

                    <Col xs={12} className={'button-field-component'}>
                        <ButtonComponent
                            text={addPaymentMethodPopupHeader} callback={addNewAccountSubmitHandler}
                        />
                    </Col>

                    <Col xs={12} className={'legend-field-component'}>
                        <Row className={'legend-field-component__field-content'}>
                            <Col xs={1} className={'legend-field-component__legend-icon'}>
                                <SvgIconComponent iconSource={IconLockXsGrey} />
                            </Col>
                            <Col xs={11} className={'legend-field-component__legend-text'}>
                                <span>
                                    All payment info is encrypted and stored securely by payments providers.<br/>
                                    We do not store your payment info on our servers.
                                </span>
                            </Col>
                        </Row>
                    </Col>

                </Row>
            </Col>

        </DefaultPopupComponent>
    )

};


export default UserDashboardWalletAddNewAccountComponent;
